import React from "react"
import { IconButton, useTheme } from "@mui/material"
import { BackIcon } from "components/icons"

export const BackIconButton = (props) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`BackIconButton`]?.styleOverrides || {}
  const { root, icon } = styleOverrides

  return (
    <IconButton
      size={props.size || "large"}
      edge="start"
      color="inherit"
      aria-label="back"
      sx={root}
      {...props}
    >
      <BackIcon sx={icon} />
    </IconButton>
  )
}
